module.exports = __webpack_public_path__ + "static/media/parcel.30bebd97.png";